/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable no-nested-ternary */
import ButtonBase from '@material-ui/core/ButtonBase'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import ChevronLeft from '@material-ui/icons/ChevronLeftRounded'
import ChevronRight from '@material-ui/icons/ChevronRightRounded'
import moment from 'moment'
import Moment from 'moment'
import MomentJalaali from 'moment-jalaali'
import momentJalaali from 'moment-jalaali'
import React, { Component, useEffect, useState } from 'react'

import {
  gregorianToJalaali,
  jalaaliToGregorian,
  DatePickerType,
  DateRangeType,
  getTimeView
} from '../../../../helpers/date'
import { useWindowDimensions } from '../../../../helpers/pageSize'
import { getDirection, lang } from '../../../../localization'
import {
  CustomDayPickerRangeControllerProps,
  MonthDetailsType
} from '../types/DateRangePicker.types'
import CustomMonthView from './CustomMonthView'
import CustomMonthViewMultiDates from './CustomMonthViewMultiDates'
import useStyles from './styles/customDayPickerRangeController.style'

const buildNewJalaaliMonth = (month: moment.Moment) => {
  const tempMonth = momentJalaali(month.clone())
  const monthLength = momentJalaali.jDaysInMonth(
    tempMonth.jYear(),
    tempMonth.jMonth()
  )
  const monthName = tempMonth.format('jMMMM')
  let numberOfEmptyDays = tempMonth.day()
  numberOfEmptyDays = numberOfEmptyDays === 6 ? 0 : numberOfEmptyDays + 1
  const newMonth = {
    firstDayDate: tempMonth,
    firstDay: tempMonth.format('jYYYY-jMM-jDD'),
    name: monthName,
    data: new Array(numberOfEmptyDays).fill(null)
  }
  for (let i = 1; i <= monthLength; i += 1) {
    newMonth.data.push(i)
  }

  return newMonth
}

const buildNewGregorianMonth = (month: moment.Moment): MonthDetailsType => {
  const tempMonth = month.clone()

  const monthLength = tempMonth.daysInMonth()
  const monthName = tempMonth.format('MMMM')

  const numberOfEmptyDays = tempMonth.day()

  const newMonth = {
    firstDayDate: tempMonth,
    firstDay: tempMonth.format('YYYY-MM-DD'),
    name: monthName,
    data: new Array(numberOfEmptyDays).fill(null)
  }

  for (let i = 1; i <= monthLength; i += 1) {
    newMonth.data.push(i)
  }

  return newMonth
}

const buildNewMonth = (
  month: moment.Moment,
  type: DatePickerType
): MonthDetailsType =>
  type === 'jalaali'
    ? buildNewJalaaliMonth(month)
    : buildNewGregorianMonth(month)

interface CalendarStartDateOptions {
  type: DatePickerType
  startDate?: string
  width: number
  enablePastDays?: boolean
  focusToday: boolean
}

export const resolveCalendarStartDate = ({
  type,
  startDate,
  width,
  enablePastDays,
  focusToday
}: CalendarStartDateOptions): moment.Moment => {
  const currentDate =
    type === 'jalaali' ? momentJalaali().clone() : moment().clone()

  if (width < 600 && enablePastDays) {
    return currentDate.subtract(1, 'year').add(1, 'month')
  }

  if (focusToday || !startDate) return currentDate

  return type === 'jalaali'
    ? momentJalaali(startDate, 'jYYYY-jMM-jDD').clone()
    : moment(startDate).clone()
}

const CustomDayPickerRangeController: React.FC<
  CustomDayPickerRangeControllerProps
> = ({
  startDate,
  endDate,
  fixedStart,
  fixedEnd,
  numberOfVisibleMonths,
  showJalaaliHolidays,
  enablePastDays,
  enableAllDays,
  onChange,
  size,
  type,
  numberOfHoveredItems,
  autoSelectedEndDate,
  range,
  multipleDates,
  dateObjectList = [],
  goToday,
  openAtToday = false,
  endDateCanBeSelectAsStartDate,
  disableBefore,
  disableAfter,
  maxRange
}) => {
  const [newdisableAfter, setnewDisableAfter] = useState<string | undefined>(
    disableAfter
  )
  const [renderedMonths, setrenderedMonths] = useState<MonthDetailsType[]>([])
  const [goToTodayDetected, setGoToTodayDetected] = useState<boolean>(false)

  const todayDay =
    type === 'jalaali'
      ? parseInt(MomentJalaali().format(getTimeView(type).dayView), 10)
      : parseInt(Moment().format(getTimeView(type).dayView), 10)

  const [leftValue, setleftValue] = useState<number>(-375)
  const [hoveredDate, sethoveredDate] = useState<string | null>(null)
  const [lastSelectedDateRangeType, setlastSelectedDateRangeType] =
    useState<DateRangeType>('END_DATE')
  const classes = useStyles()

  const { width } = useWindowDimensions()

  const renderGregorianMonths = () => {
    const calendarStartDate = resolveCalendarStartDate({
      type,
      startDate,
      width,
      enablePastDays,
      focusToday: goToTodayDetected || openAtToday
    })

    const newRenderedMonths: MonthDetailsType[] = []
    const thisMonth =
      width < 600
        ? calendarStartDate.startOf('month')
        : calendarStartDate.subtract(1, 'months').startOf('month')

    const defaultNumberOfMonths = width < 600 ? 12 : 4
    for (let j = 0; j < defaultNumberOfMonths; j += 1) {
      const newMonth = buildNewMonth(thisMonth, type)
      newRenderedMonths.push(newMonth)
      if (j !== defaultNumberOfMonths - 1) {
        thisMonth.add(1, 'months')
      }
    }

    setrenderedMonths(newRenderedMonths)
  }

  const renderJalaaliMonths = () => {
    const calendarStartDate = resolveCalendarStartDate({
      type,
      startDate,
      width,
      enablePastDays,
      focusToday: goToTodayDetected || openAtToday
    })

    const newRenderedMonths: MonthDetailsType[] = []

    const thisMonth =
      width < 600
        ? calendarStartDate.startOf('jMonth')
        : calendarStartDate.subtract(1, 'jMonth').startOf('jMonth')
    const defaultNumberOfMonths = width < 600 ? 12 : 4
    for (let j = 0; j < defaultNumberOfMonths; j += 1) {
      const newMonth = buildNewMonth(thisMonth, type)
      newRenderedMonths.push(newMonth)
      if (j !== defaultNumberOfMonths - 1) {
        thisMonth.add(1, 'jMonth')
      }
    }
    setrenderedMonths(newRenderedMonths)
  }

  const renderMonths =
    type === 'jalaali' ? renderJalaaliMonths : renderGregorianMonths

  const onSelectEndDate = (
    selectedMonth: MonthDetailsType,
    selectedDay: number,
    selectedStartDate?: string
  ) => {
    const newStartDate = selectedStartDate || startDate

    if (!selectedDay) {
      onChange({
        gregorianStartDate:
          type === 'gregorian'
            ? newStartDate
            : jalaaliToGregorian(newStartDate || ''),
        gregorianEndDate: undefined,
        jalaaliStartDate:
          type === 'jalaali'
            ? newStartDate
            : gregorianToJalaali(newStartDate || ''),
        jalaaliEndDate: undefined
      })
      return
    }
    const SelectedDate =
      selectedMonth.firstDay.slice(0, 8) +
      (selectedDay < 10 ? '0' : '') +
      selectedDay

    if (
      newStartDate &&
      !endDateCanBeSelectAsStartDate &&
      SelectedDate <= newStartDate
    ) {
      return
    }

    onChange({
      gregorianStartDate:
        type === 'gregorian'
          ? newStartDate
          : jalaaliToGregorian(newStartDate || ''),
      gregorianEndDate:
        type === 'gregorian' ? SelectedDate : jalaaliToGregorian(SelectedDate),
      jalaaliStartDate:
        type === 'jalaali'
          ? newStartDate
          : gregorianToJalaali(newStartDate || ''),
      jalaaliEndDate:
        type === 'jalaali' ? SelectedDate : gregorianToJalaali(SelectedDate)
    })
    setlastSelectedDateRangeType('END_DATE')
  }

  const handleAutoSelectEndDate = (
    selectedMonth: MonthDetailsType,
    selectedDay: number,
    SelectedDate: string
  ) => {
    if (
      selectedDay + numberOfHoveredItems! - 1 <=
      selectedMonth.data.filter((item) => !!item).length
    ) {
      onSelectEndDate(
        selectedMonth,
        selectedDay + numberOfHoveredItems! - 1,
        SelectedDate
      )
    } else {
      const startDateRenderedMonthIndex = renderedMonths.findIndex(
        (item) => item.firstDay === selectedMonth.firstDay
      )
      const calcSelectedDay =
        type === 'jalaali'
          ? parseInt(
              momentJalaali(SelectedDate, 'jYYYY/jM/jD')
                .clone()
                .add(numberOfHoveredItems! - 1, 'day')
                .format('jD'),
              10
            )
          : parseInt(
              moment(SelectedDate, 'YYYY-MM-DD')
                .clone()
                .add(numberOfHoveredItems! - 1, 'days')
                .format('D'),
              10
            )

      onSelectEndDate(
        renderedMonths[startDateRenderedMonthIndex + 1],
        calcSelectedDay,
        SelectedDate
      )
    }
  }

  const onSelectStartDate = (
    selectedMonth: MonthDetailsType,
    selectedDay: number
  ) => {
    const SelectedDate =
      selectedMonth.firstDay.slice(0, 8) +
      (selectedDay < 10 ? '0' : '') +
      selectedDay

    // Calculate the new disableAfter only if maxRange is defined and greater than zero
    let newDisableAfter
    if (maxRange && maxRange > 0) {
      newDisableAfter =
        type === 'gregorian'
          ? moment(SelectedDate).add(maxRange, 'days').format('YYYY-MM-DD')
          : momentJalaali(SelectedDate, 'jYYYY-jMM-jDD')
              .add(maxRange, 'days')
              .format('jYYYY-jMM-jDD')
    }

    onChange({
      gregorianStartDate:
        type === 'gregorian' ? SelectedDate : jalaaliToGregorian(SelectedDate),
      gregorianEndDate: undefined,
      jalaaliStartDate:
        type === 'jalaali' ? SelectedDate : gregorianToJalaali(SelectedDate),
      jalaaliEndDate: undefined
    })
    setlastSelectedDateRangeType('START_DATE')

    if (newDisableAfter) {
      setnewDisableAfter(newDisableAfter) // Store the calculated value only if maxRange exists
    }

    if (autoSelectedEndDate && numberOfHoveredItems) {
      handleAutoSelectEndDate(selectedMonth, selectedDay, SelectedDate)
    }
  }

  const onHoverDate = (
    selectedMonth: MonthDetailsType,
    selectedDay: number
  ) => {
    const SelectedDate =
      selectedMonth.firstDay.slice(0, 8) +
      (selectedDay < 10 ? '0' : '') +
      selectedDay
    sethoveredDate(SelectedDate)
  }

  const shiftBackward = () => {
    const newRenderedMonths = renderedMonths.slice(0, 3)
    const firstMonth = newRenderedMonths[0].firstDayDate.clone()
    const newMonth = buildNewMonth(
      type === 'jalaali'
        ? firstMonth.subtract(1, 'jMonth')
        : firstMonth.subtract(1, 'months'),
      type
    )
    newRenderedMonths.unshift(newMonth)
    setleftValue(-375)
    setrenderedMonths(newRenderedMonths)
  }

  const shiftForward = () => {
    const newRenderedMonths = renderedMonths.slice(1)
    const thirdMonth = newRenderedMonths[2].firstDayDate.clone()
    const newMonth = buildNewMonth(
      type === 'jalaali'
        ? thirdMonth.add(1, 'jMonth')
        : thirdMonth.add(1, 'months'),
      type
    )
    newRenderedMonths.push(newMonth)
    setleftValue(-375)
    setrenderedMonths(newRenderedMonths)
  }

  const onPrevMonthClicked = () => {
    setleftValue((currentLeftValue: number) => currentLeftValue + 375)
    setTimeout(() => shiftBackward(), 100)
  }

  const onNextMonthClicked = () => {
    setleftValue((currentLeftValue: number) => currentLeftValue - 375)

    setTimeout(() => {
      shiftForward()
    }, 100)
  }

  useEffect(() => {
    renderMonths()
    setGoToTodayDetected(true)
  }, [goToday])

  const selectedStartDate =
    lang === 'en'
      ? startDate
        ? moment(startDate).format('YYYY-MM-DD')
        : null
      : startDate
      ? startDate
      : null

  const selectedEndDate =
    lang === 'en'
      ? endDate
        ? moment(endDate).format('YYYY-MM-DD')
        : null
      : endDate
      ? endDate
      : null

  return (
    <Grid className={classes.rootGrid}>
      <Grid
        container
        className={classes.monthsListContainer}
        style={{
          left:
            getDirection() === 'ltr'
              ? width < 600
                ? 'unset'
                : width < 864
                ? leftValue - 20
                : leftValue
              : 'unset',
          right:
            getDirection() === 'rtl'
              ? width < 600
                ? 'unset'
                : width < 864
                ? leftValue - 20
                : leftValue
              : 'unset',
          transition: leftValue === -375 ? 'none' : 'all 0.1s'
        }}>
        {renderedMonths.map((singleMonth, index) => (
          <Grid
            data-cy={index == 2 ? 'datePickerMonthContainer' : null}
            item
            key={singleMonth.name}
            className={[
              index === renderedMonths.length - 1
                ? classes.datePickerLastMonth
                : ''
            ].join(' ')}>
            {multipleDates ? (
              <CustomMonthViewMultiDates
                data={singleMonth.data}
                name={singleMonth.name}
                currentMonth={singleMonth.firstDay.split('-')[1]}
                currentYear={singleMonth.firstDay.split('-')[0]}
                currentMonthFirstDay={singleMonth.firstDay}
                selectedStartDate={selectedStartDate}
                selectedEndDate={selectedEndDate}
                hoveredDate={hoveredDate}
                selectFromPast={enablePastDays}
                selectAllDays={enableAllDays}
                onSelectStartDate={(selectedDay: number) =>
                  !fixedStart
                    ? onSelectStartDate(singleMonth, selectedDay)
                    : !fixedEnd && onSelectEndDate(singleMonth, selectedDay)
                }
                onSelectEndDate={(selectedDay: number) =>
                  !fixedEnd
                    ? onSelectEndDate(singleMonth, selectedDay)
                    : !fixedStart && onSelectStartDate(singleMonth, selectedDay)
                }
                onHoverDate={(selectedDay: number) =>
                  onHoverDate(singleMonth, selectedDay)
                }
                lastSelectedDateRangeType={lastSelectedDateRangeType}
                type={type}
                showJalaaliHolidays
                range={range}
                multipleDates={multipleDates}
                selectedDatesList={dateObjectList
                  .filter(
                    (selectedDateItem) =>
                      selectedDateItem.gregorianStartDate?.split('-')[1] ===
                      singleMonth.firstDay!.split('-')[1]
                  )
                  .map((item) =>
                    parseInt(item.gregorianStartDate?.split('-')[2] || '0', 10)
                  )}
                todayDay={todayDay}
              />
            ) : (
              <CustomMonthView
                numberOfVisibleMonths={numberOfVisibleMonths}
                data={singleMonth.data}
                name={singleMonth.name}
                currentMonth={singleMonth.firstDay.split('-')[1]}
                currentYear={singleMonth.firstDay.split('-')[0]}
                currentMonthFirstDay={singleMonth.firstDay}
                selectedStartDate={selectedStartDate}
                selectedEndDate={selectedEndDate}
                hoveredDate={hoveredDate}
                selectFromPast={enablePastDays}
                selectAllDays={enableAllDays}
                onSelectStartDate={(selectedDay: number) =>
                  !fixedStart
                    ? onSelectStartDate(singleMonth, selectedDay)
                    : !fixedEnd && onSelectEndDate(singleMonth, selectedDay)
                }
                onSelectEndDate={(selectedDay: number) =>
                  !fixedEnd
                    ? onSelectEndDate(singleMonth, selectedDay)
                    : !fixedStart && onSelectStartDate(singleMonth, selectedDay)
                }
                onHoverDate={(selectedDay: number) =>
                  onHoverDate(singleMonth, selectedDay)
                }
                lastSelectedDateRangeType={lastSelectedDateRangeType}
                type={type}
                showJalaaliHolidays
                range={range}
                multipleDates={multipleDates}
                selectedDatesList={dateObjectList
                  .filter(
                    (selectedDateItem) =>
                      selectedDateItem.gregorianStartDate?.split('-')[1] ===
                      singleMonth.firstDay!.split('-')[1]
                  )
                  .map((item) =>
                    parseInt(item.gregorianStartDate?.split('-')[2] || '0', 10)
                  )}
                todayDay={todayDay}
                endDateCanBeSelectAsStartDate={endDateCanBeSelectAsStartDate}
                disableBefore={disableBefore}
                disableAfter={disableAfter || newdisableAfter}
              />
            )}
          </Grid>
        ))}
      </Grid>
      <Hidden xsDown>
        <ButtonBase
          className={classes.prevMonthButton}
          onClick={onPrevMonthClicked}>
          <ChevronLeft className={classes.prevMonthIcon} />
        </ButtonBase>
      </Hidden>
      <Hidden xsDown>
        <ButtonBase
          className={classes.nextMonthButton}
          onClick={onNextMonthClicked}>
          <ChevronRight className={classes.nextMonthIcon} />
        </ButtonBase>
      </Hidden>
    </Grid>
  )
}

export default CustomDayPickerRangeController
